import React from "react";
import { TextField, InputAdornment } from "@mui/material";

export default function TelInput({ ...rest }) {
  return (
    <TextField
      {...rest}
      sx={{
        "label, legend": {
          display: "none",
        },
        fieldset: {
          height: "60px",
          top: "0",
        },
      }}
      InputProps={{
        type: "text",
        startAdornment: (
          <InputAdornment position="start">
            <div className="bg-[#ededed] flex h-[60px] justify-center items-center -ml-[14px] px-5">
              <img
                src={require("../assets/img/benin.png")}
                style={{ height: 14, marginRight: 5 }}
              />
              <small className="text-sm">+229</small>
            </div>
          </InputAdornment>
        ),
      }}
    />
  );
}
